"use client";

import { CtaComponentProps } from "@/cms/models";
import RippleCtaButton from "./RippleCtaButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinnerThird } from "@fortawesome/duotone-regular-svg-icons";

export default function LoadingRippleButton(props: {
  children?: React.ReactNode;
  className?: string;
  config?: Partial<CtaComponentProps>;
  disabled?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  type?: "button" | "submit" | "reset" | undefined;
  isActive?: boolean;
  loading?: boolean;
}) {
  return (
    <RippleCtaButton
      {...props}
      disabled={props.disabled || props.loading}
      data-type="RippleCtaButton"
    >
      {props.loading && (
        <div className="absolute inset-0 flex items-center justify-center opacity-30">
          <FontAwesomeIcon
            className="size-6 text-[var(--filter-button-text-color)] animate-spin"
            icon={faSpinnerThird}
          />
        </div>
      )}
      {props.children}
    </RippleCtaButton>
  );
}
